// extracted by mini-css-extract-plugin
module.exports = {"postList":"PostList-module--postList--1wFVy","postItem":"PostList-module--postItem--2snXJ"};